import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class ToastService {

  private keepAfterRouteChange = false;
  private subject = new Subject();

    constructor(private router: Router) {
      // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
      router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          if (this.keepAfterRouteChange) {
            // only keep for a single route change
            this.keepAfterRouteChange = false;
          } else {
            // clear alert messages
            this.clear();
          }
        }
      });
    }
  
    getAlert(): Observable<any> {
      return this.subject.asObservable();
    }

    success(message: string, keepAfterRouteChange = false, title?: string) {
        this.alert('green', message, keepAfterRouteChange, title);
    }

    error(message: string, keepAfterRouteChange = false, title?: string) {
        this.alert('red', message, keepAfterRouteChange, title);
    }

    warning(message: string, keepAfterRouteChange = false, title?: string) {
      this.alert('orange', message, keepAfterRouteChange, title);
    }

    alert(color: string, message: string, keepAfterRouteChange = false, title?: string) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({color: color, message: message, title: title });
    }

    clear() {
      // clear alerts
      this.subject.next();
    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/toast.service.ts